import { arbitrum, arbitrumNova, base, mainnet, optimism, zora, } from 'viem/chains';
export const configureViemChain = (chain) => {
    let viemChain;
    const staticChains = [mainnet, arbitrumNova, arbitrum, base, optimism, zora];
    const staticChain = staticChains.find(({ id }) => id === chain.id);
    if (staticChain) {
        viemChain = staticChain;
    }
    else {
        viemChain = {
            id: chain.id,
            name: chain.displayName,
            network: chain.name,
            nativeCurrency: {
                name: chain.currency.name ?? 'Ethereum',
                decimals: chain.currency.decimals ?? 18,
                symbol: chain.currency.symbol ?? 'ETH',
            },
            rpcUrls: {
                default: {
                    http: [chain.httpRpcUrl],
                    webSocket: [chain.wsRpcUrl],
                },
                public: {
                    http: [chain.httpRpcUrl],
                    webSocket: [chain.wsRpcUrl],
                },
            },
            blockExplorers: {
                etherscan: {
                    name: chain.explorerName,
                    url: chain.explorerUrl,
                },
                default: {
                    name: chain.explorerName,
                    url: chain.explorerUrl,
                },
            },
        };
    }
    return {
        ...chain,
        viemChain,
        icon: {
            dark: `https://assets.relay.link/icons/${chain.id}/dark.png`,
            light: `https://assets.relay.link/icons/${chain.id}/light.png`,
        },
    };
};
export const convertViemChainToRelayChain = (chain) => {
    return {
        id: chain.id,
        name: chain.name,
        displayName: chain.name,
        httpRpcUrl: chain.rpcUrls.default && chain.rpcUrls.default && chain.rpcUrls.default
            ? chain.rpcUrls.default.http[0] ?? ''
            : '',
        wsRpcUrl: chain.rpcUrls && chain.rpcUrls.default.webSocket
            ? chain.rpcUrls.default.webSocket[0] ?? ''
            : '',
        icon: {
            dark: `https://assets.relay.link/icons/${chain.id}/dark.png`,
            light: `https://assets.relay.link/icons/${chain.id}/light.png`,
        },
        currency: chain.nativeCurrency,
        explorerUrl: chain.blockExplorers?.default.url ?? '',
        viemChain: chain,
    };
};
//# sourceMappingURL=chain.js.map